export default "__VITE_ASSET__Dz5$abz$__"